define('plugin/invoice/view/InvoicePaymentView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Payment process view
     *
     * @class InvoicePaymentView
     */
    return LayoutView.extend({

        template: '#invoice_payment_view',
        ui: {
            'container': '#sb_invoice_payment_container'
        },

        _invoiceModel: null,
        _paymentSystemModel: null,

        initialize: function () {
            this._invoiceModel = this.getOption('invoiceModel');
            this._paymentSystemModel = this.getOption('paymentSystemModel');
        },

        onShow: function () {
            if (!this._paymentSystemModel.get('storedPaymentMethod')) {
                var recurring = '';
                if (this._paymentSystemModel.get('recurring')) {
                    recurring = '/recurring/1/';
                }
                var rebilling = '';
                if (this._paymentSystemModel.get('rebilling')) {
                    rebilling = '/rebilling/1/';
                }

                var params = '';
                if (Config.getInstance().getOption('widget_type')) {
                    params = '?is-widget=1';
                }

                var url = '/v2/ext/invoice-payment/pay/system/' + this._paymentSystemModel.get('payment_system') + '/invoice_id/' + this._invoiceModel.get('id') + recurring + rebilling + params;

                $.ajaxSetup({
                    cache: true
                });
                var instance = this;
                this.ui.container.load(url, function () {
                    instance.triggerMethod('payment_processor:loaded', instance._paymentSystemModel);
                });
            } else {
                var _this = this;
                this._invoiceModel.pay(this._paymentSystemModel.get('id'), this._paymentSystemModel.get('recurring')).then(function () {
                    Backbone.history.navigate('invoice/pay/' + _this._invoiceModel.get('id') + '/return/1', {trigger: true});
                });
            }

        }

    });

});
